import React, { useState, lazy, Suspense, useEffect } from "react";
import { Container, Navbar } from "react-bootstrap";
import { isMobileDevice } from "../../Utils/index.js";
import UserWayAccessibilityMenu from "../../UserWayAccessibilityMenu/index.js";
import "./index.css";

const RigVedQuotes = lazy(() => import("../RigvedQuotes/index.js"));

export default function HeaderNav() {
  const [showRigVedQuotes, setShowRigVedQuotes] = useState(false);
  const [navbar, setNavbar] = useState(false);
  const isMobileOrTabletDevice = isMobileDevice();


  let prevScrollPos = window.scrollY;

  // Handle scroll behavior only for mobile or tablet devices
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const Navbar = document.getElementById("Navbar");

      if (currentScrollPos === 0) {
        Navbar.classList.remove("navbarTransition");
        setNavbar(false);
      } else {
        if (prevScrollPos > currentScrollPos) {
          setNavbar(true); // Scrolling up
        } else {
          if (!isMobileOrTabletDevice) {
            setNavbar(true); // Scrolling down on desktop
          } else {
            setNavbar(false);
            Navbar.classList.add("navbarTransition");
          }
        }
      }
      prevScrollPos = currentScrollPos;

      // Hide RigVedQuotes only on mobile or tablet when scrolling
      if (isMobileOrTabletDevice && showRigVedQuotes) {
        setShowRigVedQuotes(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobileOrTabletDevice, showRigVedQuotes]);

  const handleMenuClick = () => {
    if (window.scrollY > 0) {
      setNavbar(true);
    }
  };
  const toggleQuotesVisibility = () => {
    setShowRigVedQuotes(prevState => !prevState);
  };

  return (
    <>
      <div>
        <Navbar
          id="Navbar"
          collapseOnSelect
          expand="lg"
          fixed="top"
          variant="dark"
          className={navbar ? "navbar active" : "navbar"}
        >
          <Container className="navbar-container">
            <Navbar.Brand className="d-flex">
              <div className="d-flex">
                <div>
                  <a href="https://angelai.com/" target="_self" rel="noopener noreferrer">
                    <img
                      src="https://resources.swmc.com/angel-ai/latest-angelai-logo.webp"
                      alt="AngelAi logo"
                      height="auto"
                      width="auto"
                      className="main_logo"
                    />
                  </a>
                </div>
                <div className="brandTagLineContainer">
                  <p
                    className="brandTagLine"
                    onMouseOver={() => setShowRigVedQuotes(true)}
                    onMouseOut={() => setShowRigVedQuotes(false)}
                    onClick={() => setShowRigVedQuotes(true)}
                  >
                    Nothing Is Beyond Reach
                  </p>
                </div>
              </div>

            </Navbar.Brand> <Suspense fallback={<div>Loading...</div>}>
              <RigVedQuotes showRigVedQuotes={showRigVedQuotes} />
            </Suspense>
            <UserWayAccessibilityMenu color="white" width={35} height={35} />
          </Container>
        </Navbar>
      </div>
    </>
  );
}